import { styled } from 'ds/index';
import { colorToAlpha } from 'helpers/insight';
import { BasicButton } from '../button/BasicButton';
import { CleanButton } from 'ds/components/button';

export const PaginationWrapper = styled.div`
  ${({ theme }) => `
    margin: ${theme.spacing(3)} auto;
    display: flex;
    justify-content: center;
    user-select: none;
  `}
`;

export const InfinitePaginationButton = styled.div`
  ${({ theme }) => `
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${theme.spacing(2)};
    cursor: pointer;
    background: ${theme.colors.neutrals.white};
    color: ${theme.colors.neutrals.grey3};
    border-radius: ${theme.borderRadius.large};
  `}
`;

export const SimplePaginationWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;

    & > div:not(:last-of-type) {
      margin-left: ${theme.spacing(2)};
    }
    & > div:not(:first-of-type) {
      margin-left: ${theme.spacing(1)};
    }
    & > div:last-of-type {
      margin-right: ${theme.spacing(1)};
      margin-left: 0;
    }
    @media all and (max-width: 360px) {
      & > div:not(:last-of-type) {
        margin-left: ${theme.spacing(1)};
      }
      & > div:not(:first-of-type) {
        margin-left: ${theme.spacing(0.5)};
      }
      & > div:last-of-type {
        margin-right: ${theme.spacing(0.5)};
        margin-left: 0;
      }
    }
  `}
`;

export const PageSwitcher = styled(BasicButton.withComponent('div'))<{ arrowType: 'prev' | 'next'; disabled: boolean; }>`
  svg {
    transition: all .2s ease;
    transform: rotate(${({ arrowType }) => (arrowType === 'next' ? '' : '-')}90deg);
  }
`;

export const Page = styled(CleanButton.withComponent('div'))<{ isActive: boolean, isDots?: boolean, isWide?: boolean; noActiveStyles?: boolean; }>`
  ${({ theme, isActive, isDots, isWide, noActiveStyles = false }) => `
    color: ${isActive ? theme.colors.brand.main : theme.colors.neutrals.grey3};
    a {
      color: ${isActive ? theme.colors.brand.main : theme.colors.neutrals.grey3};
    }
    padding: 0;
    ${isActive ? `background-color: ${colorToAlpha(theme.colors.brand.main, 0.12)};` : ''}
    ${isDots ? `
      > div {
        margin-top: -${theme.spacing(0.5)};
        letter-spacing: 1px;
      }
    ` : 'cursor: pointer;'}
    height: 24px;
    width: ${isWide ? '34px' : '24px'};
    ${noActiveStyles && isActive ? `
      &:active, &:hover {
        color: ${theme.colors.brand.main};
        background-color: ${colorToAlpha(theme.colors.brand.main, 0.12)};

        a {
          color: ${theme.colors.brand.main};
        }
      }
    ` : ''}
  `}
`;
